import { TextBox } from '@apply/components';
import { useBorrowerEntityStreet1 } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface BorrowerStreet1Props {
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerStreet1: React.FC<BorrowerStreet1Props> = ({ readOnly = false, isReview = false }) => {
    const label = 'Street Address';
    const [street1, set_street1] = useBorrowerEntityStreet1();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={street1}
                />
            ) : (
                <TextBox
                    value={street1}
                    onChange={(value) => set_street1(value)}
                    label={label}
                    required={true}
                    readOnly={readOnly}
                    maxLength={50}
                />
            )}
        </>
    );
};
